import { render, staticRenderFns } from "./userlist.vue?vue&type=template&id=b48af154&scoped=true&"
import script from "./userlist.vue?vue&type=script&lang=js&"
export * from "./userlist.vue?vue&type=script&lang=js&"
import style0 from "./userlist.vue?vue&type=style&index=0&id=b48af154&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48af154",
  null
  
)

export default component.exports